import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';
import booksAPI from '../../sources/api/booksAPI';

// constants
import { APPOINTMENT_LIST_FETCH } from '../../constants/appointmentTypes';
import { BOOKS_CREATE } from '../../constants/booksTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentListSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { BOOK_CREATE_SUCCESS, BOOK_CREATE_ERROR } from '../../constants/messages';
import { tooltipHide } from '../../actions/tooltipActions';
import userAPI from '../../sources/api/userAPI';
import { CURRENT_USER_FETCH } from '../../constants/currentUserTypes';

export function* booksCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params      = action.payload;
  const appointment = yield select((state) => state.get('appointment'));
  const startDate   = appointment.get('start_date');
  const endDate     = appointment.get('end_date');

  try {
    yield *httpSaga(BOOKS_CREATE, call(booksAPI.create, params));
    if (startDate && endDate) {
      yield *httpSaga(APPOINTMENT_LIST_FETCH, call(appointmentAPI.all, { 'start_date': startDate, 'end_date': endDate }), appointmentListSchema);
    }
    yield put(tooltipHide({ id: params.tooltipId }));
    yield toastr.success('success', BOOK_CREATE_SUCCESS);
    yield  *httpSaga(CURRENT_USER_FETCH, call(userAPI.fetchSelf));
  } catch (e) {
    yield toastr.error(BOOK_CREATE_ERROR);
    yield put(error(BOOKS_CREATE, e));
  } finally {
    yield put(doneIndicator(BOOKS_CREATE));
  }
}

export function* watchBooksCreate() {
  yield takeEvery(BOOKS_CREATE, booksCreate);
}

export default function* root() {
  yield all([
    fork(watchBooksCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/booksCreate.js